import { gql } from '@apollo/client';

const EDIT_POST = gql`
  mutation updatePost(
      $id: String!, 
      $iconPost: String,
      $imageUrl: String, 
      $imageUrl2: String, 
      $imageUrl3: String,
      $imageUrl4: String,
      $scriptUrl: Boolean, 
      $externalSource: ExternalSourceInput,
      $tags: [String],
      $category: String,
      $title: String!, 
      $body: String!, 
      $body2: String, 
      $body3: String,
      $body4: String
    ) {
    updatePost(
        _id: $id,
        iconPost: $iconPost,
        imageUrl: $imageUrl, 
        imageUrl2: $imageUrl2, 
        imageUrl3: $imageUrl3, 
        imageUrl4: $imageUrl4,
        scriptUrl: $scriptUrl, 
        externalSource: $externalSource,
        tags: $tags,
        category: $category,
        title: $title, 
        body: $body, 
        body2: $body2, 
        body3: $body3,
        body4: $body4
      ) {
      _id
        title
        iconPost
        imageUrl
        imageUrl2
        imageUrl3
        imageUrl4
        scriptUrl
        externalSource {
          icon
          url
        }
        tags
        createdAt
        category{
          _id
          catname
        }
        body
        body2
        body3
        body4
        author {
          _id
          name
        }
        comments{
          text
        }
      }
    }`;

const CREATE_MESSAGE = gql`
  mutation createMessage($text: String, $file: String, $addressee: String!) {
    createMessage(text: $text, file: $file, addressee: $addressee) {
      _id
      text
      file
      read
      createdAt
      author {
        _id
        name
        avatar
      }
      addressee
    }
  }
`;

    const DELETE_POST = gql`
      mutation deletePost($id: String!) {
        deletePost(_id: $id)
      }
    `;

    const DELETE_COMM = gql`
    mutation deleteComment($id: String!) {
      deleteComment(_id: $id)
    }
  `;

  const DELETE_MESSAGE = gql`
    mutation deleteMessage($id: String!) {
      deleteMessage(_id: $id)
    }
  `;

  const UPDATE_USER = gql`
    mutation updateUser($name: String, $email: String, $telephone: String, $avatar: String, $bio: String) {
      updateUser(name: $name, email: $email, telephone: $telephone, avatar: $avatar, bio: $bio) {
        _id
        name
        email
        telephone
        avatar
        bio
      }
    }
  `;

  const DELETE_USER_FROM_CHATS = gql`
    mutation deleteUserFromChats($userId: ID!) {
      deleteUserfromMyListUsersChats(userId: $userId) {
        _id
        name
      }
    }
  `;

    export {
      EDIT_POST,
      DELETE_POST,
      DELETE_COMM,
      CREATE_MESSAGE,
      DELETE_MESSAGE,
      UPDATE_USER,
      DELETE_USER_FROM_CHATS
    };
